import {Stack, Typography} from '@mui/material';
import React from 'react';

import {CopySection} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {removeDuplicates} from 'presentation/utils';
import {OdontoPhonesSectionProps} from './types';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoPhonesSection({provider}: OdontoPhonesSectionProps) {
	const parsedPhones = provider.contatos ? provider.contatos : [];
	const phones = removeDuplicates(parsedPhones);
	const hasPhones = phones.length > 0;

	return (
		<Stack gap={1}>
			<Typography variant="subtitle2" color="text.secondary">
				{guideDetails.phones}
			</Typography>
			{hasPhones ? (
				<Stack gap={1.5}>
					{phones.map((item, index) => (
						<CopySection key={index} value={item} highlightedIcons />
					))}
				</Stack>
			) : (
				<Typography variant="body2" color="text.secondary">
					{guideDetails.emptyPhones}
				</Typography>
			)}
		</Stack>
	);
}
